import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import Client from '@helium/http';
import { GlobalsService } from '../globals/globals.service';
var md5 = require('md5');
var sha256 = require('js-sha256');

const heliumclient = new Client();

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  //Default headers -> set in constructor
  private httpHeaders: any;
  private apiKey: string = '';
  // private apiRoot: string = "https://localhost:3000"
  private apiRoot: string = 'https://api.atomcore.io:3000';
  public checkToken = false;

  constructor(private http: HttpClient, private globals: GlobalsService) {
    this.httpHeaders = new HttpHeaders().set(
      'Content-Type',
      'application/json'
    );
  }

  public login(
    username: string,
    password: string,
    onSuccess?: () => void,
    onFailure?: (res?: any) => void
  ) {
    //REST endpoint
    let endpoint = this.apiRoot + '/profile/login';

    var hash = sha256.create();
    hash.update(password);

    let options = {
      headers: this.httpHeaders,
      withCredentials: true,
    };

    let body: any = {
      username: username,
      hash: hash.hex(),
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.statusCode == 200) {
          //Set in globals
          if (r && r.data) {
            this.globals.activeUser = r.data;
          }

          if (onSuccess) onSuccess();
        } else {
          if (onFailure) onFailure();
        }
      },

      (error) => {
        if (onFailure) onFailure();
      }
    );
  }

  public retrieve(onSuccess?: () => void, onFailure?: (res?: any) => void) {
    //REST endpoint

    let endpoint = this.apiRoot + '/profile/retrieve';

    let options = {
      headers: this.httpHeaders,
      withCredentials: true,
    };

    let body: any = {};

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.statusCode == 200) {
          //Set in globals
          if (r && r.data && r.data.result) {
            this.globals.activeUser = r.data.result;
          }

          if (onSuccess) onSuccess();
        } else {
          if (onFailure) onFailure();
        }
      },

      (error) => {
        if (onFailure) onFailure();
      }
    );
  }

  public logout(onSuccess?: () => void, onFailure?: (res?: any) => void) {
    //REST endpoint
    let endpoint = this.apiRoot + '/profile/logout';

    let options = {
      headers: this.httpHeaders,
      withCredentials: true,
    };
    let body = {};

    //Add the token?

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.statusCode == 200) {
          if (onSuccess) onSuccess();
        }
      },

      (error) => {
        if (onFailure) onFailure();
      }
    );
  }

  public register(
    name: string,
    email: string,
    username: string,
    password: string,
    surname?: string,
    address?: string,
    mobile?: string,
    avatar?: string,
    about?: string,
    onSuccess?: () => void,
    onFailure?: (res?: any, reason?: string) => void
  ) {
    //REST endpoint
    let endpoint = this.apiRoot + '/profile/register/new';

    let options = {
      headers: this.httpHeaders,
      withCredentials: true,
    };

    var hash = sha256.create();
    hash.update(password);

    let body: any = {
      name: name,
      email: email,
      username: username,
      hash: hash.hex(),
      surname: surname,
      address: address,
      mobile: mobile,
      about: about,
      avatar: avatar,
      createEntity: true,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.statusCode == 200) {
          //TODO: this not working
          // this.logout();

          if (onSuccess) onSuccess();
        } else {
          if (onFailure) onFailure();
        }
      },

      (error) => {
        //Maybe do resend activation
        let res = false;
        let reason = undefined;
        if (error.status && error.status == 303) {
          if (error.error && error.error.data && error.error.data.action) {
            reason = error.error.data.action;
            res = true;
          }
        }
        if (onFailure) onFailure(res, reason);
      }
    );
  }

  public register_resend(
    email: string,
    onSuccess?: () => void,
    onFailure?: (res?: any) => void
  ) {
    //REST endpoint
    let endpoint = this.apiRoot + '/profile/register/resend';

    let options = {
      headers: this.httpHeaders,
      withCredentials: true,
    };

    let body: any = {
      username: email,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.statusCode == 200) {
          if (onSuccess) onSuccess();
        } else {
          if (onFailure) onFailure();
        }
      },

      (error) => {
        if (onFailure) onFailure();
      }
    );
  }

  public forgotPassword(
    username: string,
    onSuccess?: (data?: any) => void,
    onFailure?: (res?: any) => void
  ) {
    //REST endpoint
    let endpoint = this.apiRoot + '/profile/forgot_password';

    let options = {
      headers: this.httpHeaders,
      // withCredentials: true
    };

    let body: any = {
      username: username,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.statusCode == 200) {
          if (onSuccess) onSuccess(r.data);
        } else {
          if (onFailure) onFailure();
        }
      },

      (error) => {
        if (onFailure) onFailure();
      }
    );
  }

  public resetPassword(
    password: string,
    onSuccess?: (data?: any) => void,
    onFailure?: (res?: any) => void
  ) {
    let endpoint = this.apiRoot + '/profile/password/confirm_new';

    let options = {
      headers: this.httpHeaders,
      // withCredentials: true
    };

    var hash = sha256.create();
    hash.update(password);

    let body: any = {
      token: this.globals.resetToken,
      hashNew: hash.hex(),
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        // active:true
        // attempts:5
        // connections:(0) []
        // created:'2022-01-11T14:15:11.721Z'
        // email:'dewetdt@atomdesign.io'
        // id:'61dd90effd892d98466aa794'
        // last:'2022-01-14T09:22:42.818Z'
        // mobile:'0609972173'
        // name:'De Wet'
        // surname:'Du Toit'
        // username:'dewetdt@atomdesign.io'

        if (r.statusCode == 200) {
          if (onSuccess) onSuccess(r.data);
        } else {
          if (onFailure) onFailure();
        }
      },

      (error) => {
        if (onFailure) onFailure();
      }
    );
  }

  public activate(
    key: string,
    onSuccess?: (data?: any) => void,
    onFailure?: (res?: any) => void
  ) {
    let endpoint = this.apiRoot + `/profile/activate?key=${key}`;

    let options = {
      headers: this.httpHeaders,
      // withCredentials: true
    };

    let ob = this.http.get(endpoint, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.statusCode == 200) {
          if (onSuccess) onSuccess(r.data);
        } else {
          if (onFailure) onFailure();
        }
      },

      (error) => {
        if (onFailure) onFailure();
      }
    );
  }

  public minerReboot(
    snr: string,
    onSuccess?: (res?: any) => void,
    onFailure?: (res?: any) => void
  ) {
    let endpoint = this.apiRoot + `/health/miner/reboot?snr=${snr}`;

    let options = {
      headers: this.httpHeaders,
    };

    let ob = this.http.get(endpoint, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.statusCode == 200) {
          if (onSuccess) onSuccess(true);
        } else {
          if (onFailure) onFailure(false);
        }
      },

      (error) => {
        if (onFailure) onFailure(false);
      }
    );
  }

  public commissionDevices(
    devices: any[],
    type: string,
    onSuccess?: (data?: any) => void,
    onFailure?: (res?: any) => void
  ) {
    //REST endpoint
    let endpoint = this.apiRoot + '/thing/commission';

    let options = {
      headers: this.httpHeaders,
      withCredentials: true,
    };

    //Get entity
    let cons: any = this.globals.activeUser.connections;

    if (cons[0] && cons[0].entity) {
      let body: any = {
        type: type,
        entity: cons[0].entity,
        data: devices,
      };

      let ob = this.http.post(endpoint, body, options);

      ob.subscribe(
        (response) => {
          let r: any = response;

          if (r.statusCode == 200) {
            if (onSuccess) onSuccess(r.data);
          } else {
            if (onFailure) onFailure();
          }
        },

        (error) => {
          if (onFailure) onFailure();
        }
      );
    } else {
      if (onFailure) onFailure();
    }
  }

  public decommissionDevice(
    snr: string,
    type: string,
    onSuccess?: (data?: any) => void,
    onFailure?: (res?: any) => void
  ) {
    //REST endpoint
    let endpoint = this.apiRoot + '/thing/decommission';

    let options = {
      headers: this.httpHeaders,
      withCredentials: true,
    };

    //Get entity
    let cons: any = this.globals.activeUser.connections;

    if (cons[0] && cons[0].entity) {
      let body: any = {
        type: type,
        entityId: cons[0].entity,
        serial: snr,
      };

      let ob = this.http.post(endpoint, body, options);

      ob.subscribe(
        (response) => {
          let r: any = response;

          if (r.statusCode == 200) {
            if (onSuccess) onSuccess(r.data);
          } else {
            if (onFailure) onFailure();
          }
        },

        (error) => {
          if (onFailure) onFailure();
        }
      );
    } else {
      if (onFailure) onFailure();
    }
  }

  public rawListCount(
    dui: string,
    count: number,
    onSuccess?: (data?: any) => void,
    onFailure?: (res?: any) => void
  ) {
    //REST endpoint
    let endpoint = this.apiRoot + '/raw/list/count/';

    let options = {
      headers: this.httpHeaders,
      withCredentials: true,
    };

    //Get entity

    let body: any = {
      dui: dui,
      count: count,
    };

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.statusCode == 200) {
          if (onSuccess) onSuccess(r.data);
        } else {
          if (onFailure) onFailure();
        }
      },

      (error) => {
        if (onFailure) onFailure();
      }
    );
  }

  public doCheckToken() {
    let me = this;
    if (!this.checkToken) {
      this.checkToken = true;
      const interval = setInterval(function () {
        // method to be executed;
        me.retrieve(
          () => {
            // do nothing
          },
          () => {
            // do logout
            localStorage.setItem('lastpage', null);
            me.globals.currentview = 'login';
            me.checkToken = false;
            clearInterval(interval);
          }
        );
      }, 1000 * 60 * 5);
    }
  }

  public deviceList(
    onSuccess?: (devs?: any[]) => void,
    onFailure?: (res?: any) => void
  ) {
    //REST endpoint
    let endpoint = this.apiRoot + '/thing/list';

    let options = {
      headers: this.httpHeaders,
      withCredentials: true,
    };
    let body = {};

    //Add the token?

    let ob = this.http.post(endpoint, body, options);

    ob.subscribe(
      (response) => {
        let r: any = response;

        if (r.statusCode == 200) {
          if (onSuccess) onSuccess(r.data ? r.data : []);
        }
      },

      (error) => {
        if (onFailure) onFailure();
      }
    );
  }

  // Helium
  public async getHotspotActivity(
    addr: string,
    onSuccess?: (data?: any) => void,
    onFailure?: (res?: any) => void
  ) {
    try {
      let list = await heliumclient.hotspot(addr).activity.list();
      let act = await list.take(40);

      //Cleanup
      let activities = [];
      for (let i = 0; i < act.length; i++) {
        let activity: any = act[i];

        // console.log(activity.type)

        // let t = this.globals.timeSince(activity.time)

        if (activity.type == 'poc_receipts_v2') {
          //Handle beacon vs witness here
          let beacon = activity.path[0].challengee == addr ? true : false;
          activities.push({
            time: activity.time,
            height: activity.height,
            type: activity.type,
            path: activity.path,
            challenger: activity.challenger,
            challengeOwner: activity.challengeOwner,
            witnesses: activity.path[0].witnesses,
            beacon: beacon,
          });
        } else if (activity.type == 'rewards_v2') {
          activities.push({
            time: activity.time,
            height: activity.height,
            type: activity.type,
            rewards: activity.rewards[0],
          });
        } else if (activity.type == 'assert_location_v2') {
          activities.push({
            time: activity.time,
            height: activity.height,
            type: activity.type,
          });
        } else if (activity.type == 'state_channel_close_v1') {
          //Transferred packets
          activities.push({
            time: activity.time,
            height: activity.height,
            type: activity.type,
            packets: activity.stateChannel.summaries[0].numPackets,
            dc: activity.stateChannel.summaries[0].numDcs,
          });
        } else if (activity.type == 'add_gateway_v1') {
          //Transferred packets
          activities.push({
            time: activity.time,
            height: activity.height,
            type: activity.type,
          });
        }
      }

      if (activities) {
        if (onSuccess) onSuccess(activities);
      } else {
        if (onSuccess) onSuccess([]);
      }
    } catch (e: any) {
      if (onFailure) onFailure(e.message ? e.message : 'Generic Error');
    }
  }

  public async getHotspotValidator(
    addrs: string[],
    onSuccess?: (data?: any) => void,
    onFailure?: (res?: any) => void
  ) {
    // addrs.push("132MB9jBmHNNw5v6LodPdWEAnRTDEaChrpmhCYUXW1B3aa9h9ku")

    let validator: any = {
      status: null,
      name: null,
      ip: null,
      lastHeartbeat: null,
      version: null,
      listenIP: null,
      address: null,
    };

    for (let i = 0; i < addrs.length; i++) {
      let addr = addrs[i];

      try {
        let val = await heliumclient.validators.get(addr);

        if (val && val.data && val.data.blockAdded) {
          //unpack
          validator.address = val.data.address;
          validator.status = val.data.status.online == 'online' ? true : false;
          validator.name = val.data.name;
          validator.ip = getValidatorIP(val.data.status.listenAddrs[0]);
          validator.listenIP = val.data.status.listenAddrs[0];
          validator.version = getValidatorVersion(val.data.versionHeartbeat);
          validator.lastHeartbeat = val.data.lastHeartbeat;

          if (onSuccess) onSuccess(validator);
          break;
        } else {
          // if(onSuccess) onSuccess(undefined)
        }
      } catch (e: any) {
        if (onFailure) onFailure(e.message ? e.message : 'Generic Error');
      }
    }
  }
}

function getValidatorIP(str: string) {
  let ip = str;
  ip = ip.replace(/\/ip4\//, '');
  ip = ip.replace(/\/tcp\/.*/, '');
  return ip;
}

function getValidatorVersion(number: number) {
  let version = number.toString();
  let val1 = version.padStart(10, '0');
  let ver = parseInt(val1.substring(0, 3));
  let ver1 = parseInt(val1.substring(3, 6));
  let ver2 = parseInt(val1.substring(6, 10));
  return `${ver}.${ver1}.${ver2}`;
}
